import { DOMAIN_URL } from '../config-global'

// ----------------------------- Constants ----------------------------- //
export const MSAL_LS_KEY = 'authInfo'
export const JWT_LS_KEY = 'jwtToken'
export const USER_LS_KEY = 'user'
const Alert_LS_KEY = 'lastActionId'
const USER_ROLE = 'role'
// ----------------------------- User ----------------------------- //
export const loginRequest = {
  scopes: ['user.read', 'openid', 'profile'], // The required scopes for authentication and accessing user information
}
const GET_USER_ROLE = () => {
  const data = GET_USER()
  return data?.[USER_ROLE] || 'user'
}
export const IS_ADMIN = () => {
  return GET_USER_ROLE() === 'admin'
}
export const GET_STRAPI_TOKEN = () => {
  const data = GET_USER()
  return `Bearer ${data?.strapiToken}`
}
const SHORT_NAME = data => {
  try {
    const { firstName, lastName } = data
    return firstName.split('')[0] + lastName.split('')[0]
  } catch (error) {
    return '- -'
  }
}
export const GET_IMAGE = () => {
  const data = GET_USER()
  return data?.profilePic || SHORT_NAME(data)
}

export const GET_USER = () => {
  try {
    let data = localStorage.getItem('user')
    data = JSON.parse(data || '{}')
    if (data?.name) return data
  } catch (error) {}
  return {}
}
export const GET_MAIL = () => {
  try {
    let data = GET_USER()
    return data?.email || '- -'
  } catch (error) {
    return ''
  }
}
export const FIRST_NAME = () => {
  const data = GET_USER()
  return data?.firstName || '- -'
}

export const LAST_NAME = () => {
  const data = GET_USER()
  return data?.lastName || '- -'
}

export const FULL_NAME = () => {
  const data = GET_USER()
  return data?.name
}

export const clearLoacalStorageAPIData = (key = 'storeInLocal') => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error('Error clearing local storage:', error)
  }
}
const twoDays = 24 * 60 * 60 * 2
export const CheckToeknExpiry = () => {
  const user = GET_USER()
  const { exp } = user
  if(!exp) return true
  const expFormat = isNaN(exp) ? parseInt(new Date(exp).getTime()/1000) : exp
  const currentTime = new Date().getTime()
  const tokenExpiry = (expFormat + twoDays) * 1000
  if (currentTime > tokenExpiry) {
    return true
  }
  return false
}
// ----------------------------- Auth ----------------------------- //
export const CHECK_LOGIN_STATUS = forceSet => {
  if (forceSet) {
    localStorage.setItem('loginInProgress', true)
  } else {
    const flag = localStorage.getItem('loginInProgress') || false
    if (flag) {
      localStorage.removeItem('loginInProgress')
      return true
    }
  }
}

export const GET_AccessToken = () => {
  const data = localStorage.getItem(MSAL_LS_KEY)
  return JSON.parse(data)?.accessToken || ''
}
export function GET_JWTToken() {
  return localStorage.getItem(JWT_LS_KEY) || ''
}
export const Remove_AccessToken = () => {
  try {
    localStorage.removeItem(MSAL_LS_KEY)
  } catch (error) {
    console.error('Error removing access token:', error)
  }
}
export const GET_LAST_ACTION_ID = () => {
  const user = localStorage.getItem(USER_LS_KEY) || '{}'
  return JSON.parse(user)?.[Alert_LS_KEY] || ''
}
export const SET_LAST_ACTION_ID = id => {
  try {
    const user = localStorage.getItem(USER_LS_KEY)
    const data = JSON.parse(user || '{}')
    data[Alert_LS_KEY] = id
    localStorage.setItem(USER_LS_KEY, JSON.stringify(data))
  } catch (error) {
    console.error('Error setting last action id:', error)
  }
}
export const PREV_PATH = () => localStorage.getItem('lastPath')
export const SET_PREV_PATH = path => localStorage.setItem('lastPath', path)
export const ClearSeassion = async () => {
  sessionStorage.clear()
  localStorage.clear()
}
// ----------------------------- MSAL ----------------------------- //
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: process.env.REACT_APP_MSAL_AUTHORITY_LINK,
    redirectUri: DOMAIN_URL + '/auth/login?redirectFrom=MSAL', // don't change this => configured in Azure
    // redirectUri: 'http://localhost:3000/auth/login?redirectFrom=MSAL', // don't change this => configured in Azure
    postLogoutRedirectUri: DOMAIN_URL + '/auth/login?redirectFrom=HOME',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
  scopes: ['openid', 'profile', 'offline_access'], // Include 'offline_access' scope
}

export const isTestPassed = () => {
  const user = GET_USER()
  return user?.score
}


export const versionControl = () => {
  const currentV = process.env.REACT_APP_VERSION;
  const lastV = localStorage.getItem('version');
  if (currentV !== lastV) {
    ClearSeassion();
    setTimeout(() => {
      localStorage.setItem('version', currentV);
      window.location.reload();
    }, 0);
  }
}